import { render, staticRenderFns } from "./StudipLoadingSkeleton.vue?vue&type=template&id=8c3364a0&"
import script from "./StudipLoadingSkeleton.vue?vue&type=script&lang=js&"
export * from "./StudipLoadingSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports